import { useSessionStore } from '@/src/hooks/use_session_store'
import { doc, getFirestore, onSnapshot, updateDoc } from 'firebase/firestore'
import { useEffect, useRef } from 'react'
import { useSocketIoListener } from './useSocketIoListener.hook'

// TODO: V Add a session uuid or an action system so we can exclude browser that initiated the action from subscribers

export const useCacheControlListener = () => {
  const { user, logout } = useSessionStore()
  const userId = user?.id
  const db = getFirestore()
  const firstCheck = useRef(true)

  // Firebase Firestore listener (legacy admin panel approach)
  useEffect(() => {
    if (!userId) return

    const cacheControlRef = doc(db, `cacheControl/${userId}`)
    const unsubscribeToCacheControl = onSnapshot(cacheControlRef, snap => {
      if (!snap.exists()) return
      const data = snap.data()
      if (data.global === true) {
        !firstCheck.current && logout()
        updateDoc(cacheControlRef, { global: false })
      }
      firstCheck.current = false
    })

    return () => {
      unsubscribeToCacheControl()
    }
  }, [userId])

  // Socket.IO listener (modern approach)
  // Emit an event like so from the backend: this.socketIoGateway.emitToUser(user.firebaseId, 'user.cacheControl', { forceClearCache: true })
  useSocketIoListener('user.cacheControl', (data: { forceClearCache: boolean }) => {
    if (!user) {
      return
    }

    if (data.forceClearCache) {
      logout()
    }
  })
}
